var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ide-iframe"},[_c('iframe',{staticClass:"ide-iframe",attrs:{"frameborder":"0","name":"ideIframe","src":_vm.frameUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }